import { createContext, type MouseEvent, useContext } from 'react';
import type { PageUIClick, PageUIClickAction } from '../../../utils/PageUI/clickFromSection';

export type PageUIActions = {
  /** The link for an action, so the browser's own new-tab, middle-click and copy-link still work. */
  getHref: (action: PageUIClickAction) => string;
  /** Carries out a click's action, and logs it, in place of the browser following the link. */
  onClick: (click: PageUIClick, event: MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * Lets the hosting app carry out section click actions without layout depending on it, since where an action goes depends on
 * the page showing the response. Without a provider, trail cards open the standalone trail page in a new tab.
 */
export const PageUIActionContext = createContext<PageUIActions | undefined>(undefined);

export const usePageUIActions = () => useContext(PageUIActionContext);
